import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import CatalogSection from './components/CatalogSection';
import RecipesSection from './components/RecipesSection';
import NewsSection from './components/NewsSection';
import InstagramSection from './components/InstagramSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProductsSection />
        <CatalogSection />
        <RecipesSection />
        <InstagramSection />
        <NewsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}